module.exports = __webpack_public_path__ + "img/logo.192b9d3c.svg";